
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsConfigDialog extends Serenity.EntityDialog<PsConfigRow, any> {
        protected getFormKey() { return PsConfigForm.formKey; }
        protected getIdProperty() { return PsConfigRow.idProperty; }
        protected getLocalTextPrefix() { return PsConfigRow.localTextPrefix; }
        protected getNameProperty() { return PsConfigRow.nameProperty; }
        protected getService() { return PsConfigService.baseUrl; }
        protected getDeletePermission() { return PsConfigRow.deletePermission; }
        protected getInsertPermission() { return PsConfigRow.insertPermission; }
        protected getUpdatePermission() { return PsConfigRow.updatePermission; }

        protected form = new PsConfigForm(this.idPrefix);

    }
}